module.exports = __webpack_public_path__ + "static/media/invoice_selected.10228210.svg";